import React from "react";

const loading = () => <div className=""></div>;

interface DefaultLayoutProps {
  children?: any;
}

const DefaultLayout = (props: DefaultLayoutProps) => {

  React.useEffect(() => {
    if (document.body)
      document.body.classList.add(
        "authentication-bg",
        "authentication-bg-pattern"
      );

    return () => {
      if (document.body)
        document.body.classList.remove(
          "authentication-bg",
          "authentication-bg-pattern"
        );
    };
  }, []);

  const children = props["children"] || null;

  return (
    <React.Suspense fallback={loading()}>
      {children}
    </React.Suspense>
  );
};
export default DefaultLayout;
